const NAMESPACE = "stripeConnect";

const KEYS = {
    ePaymentsNotEnabledText: "ePaymentsNotEnabledText",
    ePaymentsAreEnabledNotStripeText: "ePaymentsAreEnabledNotStripeText",
    stripeConnectedText: "stripeConnectedText",
    stripeNotConnectedText: "stripeNotConnectedText",
    stripeDisconnectingMessage: "stripeDisconnectingMessage"
};

const MESSAGES = {
    [KEYS.ePaymentsNotEnabledText]: {
        value: "ePayments are not enabled for this program.",
        comment: "Text to display if ePayments have not been enabled for the program"
    },
    [KEYS.ePaymentsAreEnabledNotStripeText]: {
        value: "ePayments are enabled for this program, but not with Stripe.",
        comment: "Text to display if ePayments have been enabled for the program, but not with Stripe"
    },
    [KEYS.stripeConnectedText]: {
        value: "Connected with Stripe.",
        comment: "Text to display if the program has been connected with Stripe"
    },
    [KEYS.stripeNotConnectedText]: {
        value: "Not connected with Stripe.",
        comment: "Text to display if the program has not been connected with Stripe"
    },
    [KEYS.stripeDisconnectingMessage]: {
        value: "Disconnecting from Stripe...",
        comment: "Message to display when in the process of disconnecting from Stripe"
    }
};

export { NAMESPACE, KEYS, MESSAGES };
